export const list = {
  title: {
    name: '项目名称',
    key: 'project_name',
    check: true
  },
  created_user: {
    name: '创建者',
    key: 'created_user.realname',
  },
  create_time: {
    name: '创建时间',
    key: 'create_time',
  },
  number_of_projects: {
    name: '子项目数',
    key: 'number_of_projects'
  }
};
